
import { ConsentCheckBoxGroupProps } from "@components/hooks/utils/types/propTypes";
import { useDisclosure } from "@mantine/hooks";
import { Modal, Button } from "@mantine/core";

const modalTncContent =
    "I hereby consent that Niva Bupa Health Insurance Co. Ltd. shall retrieve data associated with this mobile number to personalise my experience and ensure accurate and smooth communication.";
const modalTncContent2 =
    "I understand that my personal information shall be handled in accordance with applicable data protections laws and regulations and the Niva Bupa’s Privacy Policy.";
const ConsentCheckBox = ({ activeStep, isCheckedTerms, onClickCheckBox }: ConsentCheckBoxGroupProps) => {
    const [opened, { open, close }] = useDisclosure(false);
    const onChangeCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
        onClickCheckBox(e.target.checked)
    };
    return (
        <>
            <Modal.Root opened={opened} centered onClose={close}>
                <Modal.Overlay />
                <Modal.Content>
                    <Modal.Header>
                        <Modal.Title className="text-base  font-semibold text-nivabupa-blue-ethinosPlanRecommendation text-center w-full">
                            Terms & Conditions
                        </Modal.Title>
                        <Modal.CloseButton className="text-nivabupa-blue-ethinosPlanRecommendation" />
                    </Modal.Header>
                    <Modal.Body>
                        <p className="text-xs text-nivabupa-ethinosBlack mb-3 px-5">
                            {modalTncContent}
                        </p>
                        <p className="text-xs text-nivabupa-ethinosBlack mb-3 px-5">
                            {modalTncContent2}
                        </p>
                    </Modal.Body>
                </Modal.Content>
            </Modal.Root>
            {
                activeStep == 1 && (
                    <div className="flex flex-col mb-0">
                        <label className="relative flex items-start cursor-pointer gap-2  ">
                            <input type="checkbox" name="" id="agree_to_niva_bupa_checkbox" checked={isCheckedTerms} className="peer hidden" onChange={onChangeCheckBox} />
                            <span id="agree_to_niva_bupa_checkbox" className="w-[17px] h-[17px] shrink-0 border-2 border-[#FFAF14] rounded-[3px]"></span>
                            <span id="agree_to_niva_bupa_checkbox" className="hidden w-[17px] h-[17px] absolute peer-checked:block">
                                <svg
                                    className=""
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    id="agree_to_niva_bupa_checkbox"
                                >
                                    <rect id="agree_to_niva_bupa_checkbox" width="17" height="17" rx="3" fill="#FFAF14" />
                                    <path
                                        d="M3.84668 8.5L7.24668 11.9"
                                        stroke="white"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        id="agree_to_niva_bupa_checkbox"
                                    />
                                    <path
                                        d="M14.0469 5.1001L7.24687 11.9001"
                                        stroke="white"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        id="agree_to_niva_bupa_checkbox"
                                    />
                                </svg>
                            </span>
                            <span id="agree_to_niva_bupa_checkbox" className="text-nivabupa-ethinosBlack  text-sm xl:text-sm">
                                By clicking, I agree to Niva Bupa 
                            </span>
                            <button
                                id="view_terms_and_conditions_button"
                                onClick={(e)=>{open(); e.preventDefault();}}
                                className="text-nivabupa-blue-ethinosPlanRecommendation underline cursor-pointer text-xs md:text-sm xl:text-sm"
                            >
                                Terms &amp; Conditions
                            </button>
                        </label>
                    </div>
                )
            }
        </>
    );
};

export default ConsentCheckBox;
